import React from 'react';
import { translate } from 'components/Translation';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Route, Switch } from 'react-router-dom';
import ListOfActivities from 'views/Activities/ListOfActivities';

interface IIndexProps {
	match: {
		path: string;
	};
}

const Index = ({ match }: IIndexProps) => {
	return (
		<>
			<BreadcrumbsItem to="/dashboard/list-of-activities">{translate('path.list.of.activities')}</BreadcrumbsItem>
			<Switch>
				<Route path={match.path} exact render={(props: any) => <ListOfActivities {...props} />} />
			</Switch>
		</>
	);
};

export default Index;
